/*
  
*/
var Filter = require('./refiner').Filter;

exports.Refiner = function UnlikelyFormatFilter() {
  Filter.call(this);

  this.isValid = function (text, result, opt) {
    if (result.text.replace(' ', '').match(/^\d*(\.\d*)?$/)) {
      return false;
    }

    return true;
  };
};